export default {
  props: ["id"],
  data() {
    return {
      observer: null,
      currentPartnerSlide: 0,
      partnerImages: [
        'https://songhancapital.com/assets/image/doitac_new_3.jpg',
        'https://songhancapital.com/assets/image/doitac_new_4.jpg',
        'https://songhancapital.com/assets/image/doi_tac_new_5.jpg',
      ],
      showImageModal: false,
      selectedImage: { src: '', alt: '' },
      savedScrollPosition: 0,
      handleEscape: null,
      originalBodyOverflow: '',
      originalBodyPosition: '',
      originalBodyTop: '',
      originalBodyWidth: ''
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.initializeAnimations();

    setInterval(() => {
      this.nextPartnerSlide();
    }, 5000);

    this.handleEscape = (e) => {
      if (e.key === 'Escape' && this.showImageModal) {
        this.closeImageModal();
      }
    };
    document.addEventListener('keydown', this.handleEscape);
  },
  methods: {
    openImageModal(imageSrc, imageAlt) {
      this.selectedImage = { src: imageSrc, alt: imageAlt };

      this.savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      this.originalBodyOverflow = document.body.style.overflow;
      this.originalBodyPosition = document.body.style.position;
      this.originalBodyTop = document.body.style.top;
      this.originalBodyWidth = document.body.style.width;
      
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.savedScrollPosition}px`;
      document.body.style.width = '100%';
      
      this.showImageModal = true;
    },
    
    closeImageModal() {
      this.showImageModal = false;
      this.selectedImage = { src: '', alt: '' };

      document.body.style.overflow = this.originalBodyOverflow;
      document.body.style.position = this.originalBodyPosition;
      document.body.style.top = this.originalBodyTop;
      document.body.style.width = this.originalBodyWidth;
      
      window.scrollTo({
        top: this.savedScrollPosition,
        behavior: 'instant'
      });
    },
    
    nextPartnerSlide() {
      this.currentPartnerSlide = (this.currentPartnerSlide + 1) % 2;
    },
    
    prevPartnerSlide() {
      this.currentPartnerSlide = this.currentPartnerSlide === 0 ? 1 : 0;
    },
    
    goToPartnerSlide(index) {
      this.currentPartnerSlide = index;
    },
    
    goToContact() {
      this.$router.push('/contact');
    },
    
    initializeAnimations() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");

              const delay =
                Array.from(entry.target.parentNode.children).indexOf(
                  entry.target
                ) * 100;
              setTimeout(() => {
                entry.target.style.transitionDelay = `${delay}ms`;
              }, 0);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: "0px 0px -50px 0px",
        }
      );

      this.$nextTick(() => {
        const animatedElements =
          document.querySelectorAll(".animate-on-scroll");
        animatedElements.forEach((el) => {
          this.observer.observe(el);
        });
      });
    },
  },
  
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    
    if (this.handleEscape) {
      document.removeEventListener('keydown', this.handleEscape);
    }
    
    if (this.showImageModal) {
      document.body.style.overflow = this.originalBodyOverflow;
      document.body.style.position = this.originalBodyPosition;
      document.body.style.top = this.originalBodyTop;
      document.body.style.width = this.originalBodyWidth;
    }
  }
};